import { KineProvider } from "../providers/KineProvider";
import { NewApplicationProvider } from "../providers/NewApplicationProvider";
import { Outlet } from "react-router-dom";


const ApplicationForm = () => {

    return (
        <p>Application form</p>
    )
}

export function ApplicationFormContainer() {
    return (
        <NewApplicationProvider>
            <KineProvider>
                <Outlet />
            </KineProvider>
        </NewApplicationProvider>
    )
}

export default ApplicationForm;